/* src/app/shared/components/modals/yes-no/yes-no.component.scss */
/*# sourceMappingURL=yes-no.component.css.map */
